module.exports = __webpack_public_path__ + "img/markPoint4.f324aa03.png";